/**
 * Barra de filtros por estado compartida por los entornos RECIBIDAS y EMITIDAS,
 * para que la lista de documentos se filtre igual en los dos sitios.
 */
import { Button } from "@/components/ui/button";

export type DocStatusFilterValue = "all" | "pending" | "ready";

interface DocStatusFilterProps {
  value: DocStatusFilterValue;
  onChange: (value: DocStatusFilterValue) => void;
  counts: { all: number; pending: number; ready: number };
}

const OPTIONS: { key: DocStatusFilterValue; label: string }[] = [
  { key: "all", label: "Todas" },
  { key: "pending", label: "Con avisos" },
  { key: "ready", label: "Listas" },
];

const DocStatusFilter = ({ value, onChange, counts }: DocStatusFilterProps) => (
  <div className="flex items-center gap-1 flex-wrap">
    {OPTIONS.map((opt) => (
      <Button
        key={opt.key}
        type="button"
        size="sm"
        variant={value === opt.key ? "default" : "outline"}
        className="h-7 text-xs"
        onClick={() => onChange(opt.key)}
      >
        {opt.label} ({counts[opt.key]})
      </Button>
    ))}
  </div>
);

export default DocStatusFilter;
